import { Pipe, PipeTransform } from '@angular/core';

import { AccountGroupMembership } from '../models/account.model';

import includes from 'lodash-es/includes';

@Pipe({
  name: 'appFilterMemberships',
})
export class FilterMembershipsPipe implements PipeTransform {
  transform(
    memberships: AccountGroupMembership[] = [],
    includeGroupIds: string[] = [],
    excludeGroupIds: string[] = [],
  ): AccountGroupMembership[] {
    const includedFilter = memberships.filter(
      (membership: AccountGroupMembership) => {
        return includes(includeGroupIds, membership.document._id);
      },
    );
    const excludedFilter = memberships.filter(
      (membership: AccountGroupMembership) => {
        return !includes(excludeGroupIds, membership.document._id);
      },
    );

    if (includeGroupIds.length) {
      return includedFilter;
    }

    if (excludeGroupIds.length) {
      return excludedFilter;
    }

    return memberships;
  }
}
